import { analiticaInstance } from 'shared/analitica'

const kycOnboardingEventsMetaData = {
  owner: 'onboarding_signup',
  product: 'kyc_web',
  reference: 'view',
  project: 'stone'
}

export type KycEvents =
  | 'viewKycOnboardingScreen'
  | 'viewKycAnalysisPendingScreen'
  | 'viewKycRejectScreen'
  | 'qrCodeRedirectScreen'

const kycOnboardingEvents = analiticaInstance.eventFactory('KYC Onboarding', {
  screens: {
    viewKycOnboardingScreen: () => ({
      label: 'page-viewed',
      metadata: {
        ...kycOnboardingEventsMetaData,
        description: 'Visualização da tela de Onboarding de KYC',
        screen: 'onboarding'
      }
    }),
    viewKycAnalysisPendingScreen: () => ({
      label: 'page-viewed',
      metadata: {
        ...kycOnboardingEventsMetaData,
        description: 'Visualização da tela de Feedback de KYC',
        screen: 'feedback'
      }
    }),
    viewKycRejectScreen: () => ({
      label: 'page-viewed',
      metadata: {
        ...kycOnboardingEventsMetaData,
        description: 'Visualização da tela de Rejeite Total de KYC',
        screen: 'rejeite_total'
      }
    }),
    qrCodeRedirectScreen: (os?: 'iOS' | 'Android') => ({
      label: 'page-viewed',
      metadata: {
        ...kycOnboardingEventsMetaData,
        description: 'Visualização da tela de redirecionamento via QR Code',
        screen: 'qr_code_onboarding',
        os: os || 'Sistema não identificado'
      }
    })
  }
})

export const eventsKycOnboarding = (kycEvents: KycEvents, os?: 'iOS' | 'Android') => {
  if (kycEvents === 'qrCodeRedirectScreen' && os) {
    return kycOnboardingEvents.events.screens.qrCodeRedirectScreen(os)
  }
  return kycOnboardingEvents.events.screens[kycEvents]()
}
